// src/config.js
let API_BASE_URL = "https://stagelarpapi.zovaya.net/"; // fallback

export const loadConfig = async () => {
  try {
    const response = await fetch("/config.json");
    const data = await response.json();
    API_BASE_URL = data.API_BASE_URL;
  } catch (e) {
    console.warn("Using default API URL");
  }
};

// Export the string, not a function
export { API_BASE_URL };
